import * as types from './mutation_types'
import axios from 'axios'
import { ENTRYPOINT } from '../../../config/entrypoint'

export const setProjectData = ({ commit }, data) => {
  commit(types.PROJECT_NAME, data.nom)
  commit(types.PROJECT_CONTACT_NAME, data.concactNom)
  commit(types.PROJECT_CODE, data.code)
  commit(types.PROJECT_CONTACT_TEL1, data.contactTel1)
  commit(types.PROJECT_CONTACT_TEL2, data.contactTel2)
  commit(types.PROJECT_CONTACT_EMAIL, data.contactEmail)
  commit(types.PROJECT_CONTACT_ADRESSE, data.adresse)
  commit(types.PROJECT_CONTACT_COMPLEMENT_ADRESSE, data.complementAdresse)
  commit(types.PROJECT_CONTACT_CODE_POSTAL, data.codePostal)
  commit(types.PROJECT_CONTACT_VILLE, data.ville)
  commit(types.PROJECT_CONTACT_DEPARTEMENT, data.departement)
  commit(types.PROJECT_CONTACT_SOCIETE, data.societeId)
  commit(types.PROJECT_CONTACT_TYPE_OPERATION, data.typeOperation)
  commit(types.PROJECT_CONTACT_TYPE_ERP, data.typeErp)
  commit(types.PROJECT_CONTACT_CLIENT, data.client)
  commit(types.PROJECT_CONTACT_ETAT, data.etat)
  commit(types.PROJECT_CONTACT_NUMERO_AFFAIRE, data.numeroAffaire)
}

export const setId = ({ commit }, data) => {
  commit(types.PROJECT_ID, data)
}

export const setName = ({ commit }, data) => {
  commit(types.PROJECT_NAME, data)
}
export const setContactName = ({ commit }, data) => {
  commit(types.PROJECT_CONTACT_NAME, data)
}
export const setCode = ({ commit }, data) => {
  commit(types.PROJECT_CODE, data)
}
export const setContactTel1 = ({ commit }, data) => {
  commit(types.PROJECT_CONTACT_TEL1, data)
}
export const setContactTel2 = ({ commit }, data) => {
  commit(types.PROJECT_CONTACT_TEL2, data)
}
export const setContactEmail = ({ commit }, data) => {
  commit(types.PROJECT_CONTACT_EMAIL, data)
}
export const setContactAdresse = ({ commit }, data) => {
  commit(types.PROJECT_CONTACT_ADRESSE, data)
}
export const setContactComplementAdresse = ({ commit }, data) => {
  commit(types.PROJECT_CONTACT_COMPLEMENT_ADRESSE, data)
}
export const setContactCodePostal = ({ commit }, data) => {
  commit(types.PROJECT_CONTACT_CODE_POSTAL, data)
}
export const setContactVille = ({ commit }, data) => {
  commit(types.PROJECT_CONTACT_VILLE, data)
}
export const setContactDepartement = ({ commit }, data) => {
  commit(types.PROJECT_CONTACT_DEPARTEMENT, data)
}
export const setContactSociete = ({ commit }, data) => {
  commit(types.PROJECT_CONTACT_SOCIETE, data)
}
export const setContactTypeOperation = ({ commit }, data) => {
  commit(types.PROJECT_CONTACT_TYPE_OPERATION, data)
}
export const setCOntactTypeErp = ({ commit }, data) => {
  commit(types.PROJECT_CONTACT_TYPE_ERP, data)
}
export const setContactClient = ({ commit }, data) => {
  commit(types.PROJECT_CONTACT_CLIENT, data)
}
export const setContactEtat = ({ commit }, data) => {
  commit(types.PROJECT_CONTACT_ETAT, data)
}

export const getTypeErp = ({ commit }) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resp = await axios({ url: ENTRYPOINT + '/api/type-erp/liste?page=0', method: 'GET' })
      resolve(resp.data.data)
    } catch (err) {
      reject(err.response.data.message)
    }
  })
}

export const getTypeOperation = ({ commit }) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resp = await axios({ url: ENTRYPOINT + '/api/type-operation/liste?page=0', method: 'GET' })
      resolve(resp.data.data)
    } catch (err) {
      reject(err.response.data.message)
    }
  })
}

export const getDepartement = ({ commit }, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resp = await axios({ url: ENTRYPOINT + '/api/departements/search-code/' + data + '?page=0', method: 'GET' })
      resolve(resp.data.data)
    } catch (err) {
      reject(err.response.data.message)
    }
  })
}

export const getDepartements = ({ commit }) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resp = await axios({ url: ENTRYPOINT + '/api/departements/liste?page=0', method: 'GET' })
      resolve(resp.data.data)
    } catch (err) {
      reject(err.response.data.message)
    }
  })
}

export const addProject = ({ commit }, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resp = await axios({ url: ENTRYPOINT + '/api/projets/ajout', data, method: 'POST' })
      resolve(resp.data.data)
    } catch (err) {
      reject(err.response.data.message)
    }
  })
}

export const getProjectsByClient = ({ commit }, { socId, clientId, page }) => {
  clientId = 0 // mis a 0 car inutilisé
  return new Promise(async (resolve, reject) => {
    try {
      const resp = await axios({ url: ENTRYPOINT + '/api/projets/liste/' + socId + '/' + clientId + '?page=' + page, method: 'GET' })
      commit(types.LIST_PROJETS, resp.data.data.items)
      resolve(resp.data.data)
    } catch (err) {
      reject(err.response.data.message)
    }
  })
}

export const getProjectById = ({ commit, state }, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resp = data.mode ? await axios({ url: ENTRYPOINT + '/invite/projets/' + data.data, method: 'GET' }) : await axios({ url: ENTRYPOINT + '/api/projets/' + data, method: 'GET' })
      resolve(resp.data.data)
    } catch (err) {
      reject(err.response.data.message)
    }
  })
}

export const deleteProject = async ({ commit }, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resp = await axios({ url: ENTRYPOINT + '/api/projets/supprime/' + data, method: 'DELETE' })
      resolve(resp)
    } catch (err) {
      reject(err.response.data.data.error)
    }
  })
}

export const modificationProjet = ({ commit }, { idProjet, form }) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resp = await axios({ url: ENTRYPOINT + '/api/projets/modification/' + idProjet, data: form, method: 'POST' })
      resolve(resp)
    } catch (err) {
      reject(err.response.data.data.error)
    }
  })
}

export const getFilterResults = ({ commit }, { id, data }) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resp = await axios({ url: ENTRYPOINT + '/api/projets/liste-filtre/' + id + '?' + data, method: 'GET' })
      resolve(resp.data.data.items)
    } catch (err) {
      reject(err.response.data.data.error)
    }
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/projectForm/actions.js